import React from 'react';
import { Work } from '../types/WorkType';
import Request from '../utils/Request';
import $ from 'jquery';
import Plyr from 'plyr-react';
import LoadingComponent from '../components/LoadingComponent';

type State = {
  page: number;
  videos: Work[];
  isLastItem: boolean;
  isLoad: boolean;
  loadedPages: number[];
};

type Prop = {
  loading?: React.RefObject<LoadingComponent | null>;
};

export default class VideosPage extends React.Component<Prop, State> {
  private countPerPage = 10;
  private lastListener: (() => void) | undefined = undefined;

  constructor(props: Prop) {
    super(props);
    this.state = { page: 1, videos: [], isLastItem: false, loadedPages: [], isLoad: false };
  }

  componentDidMount() {
    this.loadVideos();
  }

  loadVideos() {
    this.setState({ videos: [] });
    Request.sendRequest(`works?count=${this.countPerPage}&category=2`).then((x) => {
      const result = x.data;
      if (result.success) {
        this.addVideos(result.data);
      }

      this.lastListener = () => this.loadMore();
      $(window).on('scroll', this.lastListener);
      this.props.loading?.current?.closeAnimation();
    });
  }

  addVideos(videos: Work[]): void {
    this.setState({ videos: [...this.state.videos, ...videos] });
  }

  loadMore() {
    const hDocument = $(document).height() ?? 0;
    const hWindow = $(window).height() ?? 0;
    const sWindow = Number.parseInt(($(window).scrollTop() ?? 0).toString());
    const diffs = hDocument - hWindow - 100;

    if (sWindow <= diffs || this.state.isLastItem || this.state.isLoad) return;
    const currentPage = this.state.page + 1;
    if (this.state.isLoad || currentPage == 1 || currentPage in this.state.loadedPages) return;
    this.setState({
      page: this.state.page + 1,
      loadedPages: [...this.state.loadedPages, currentPage]
    });
    this.setState({ isLoad: true });
    Request.sendRequest(`works?category=2&count=${this.countPerPage}&page=${this.state.page}`).then(
      (x) => {
        const result = x.data;
        if (result.success && result.data.length) {
          this.addVideos(result.data);
        } else if (result.data.length === 0) {
          this.setState({ isLastItem: true });
        }
        this.setState({ isLoad: false });
      }
    );
  }

  render(): React.ReactNode {
    return (
      <>
        <div className="videos-page container">
          {this.state.videos.map((video) => (
            <div key={`video-${video.id}`} className="mb-5 video">
              <div className="player rounded">
                <Plyr
                  source={{
                    type: 'video',
                    sources: [
                      {
                        src: video.gallery.url
                      }
                    ]
                  }}
                />
              </div>
              <h3>{video.title}</h3>
              <p>{video.details}</p>
            </div>
          ))}
        </div>
      </>
    );
  }
}
